module.exports = __webpack_public_path__ + "static/media/16.06ea3be4.png";